var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2173 46C92.2173 71.1275 71.783 91.5 46.5728 91.5C21.3625 91.5 0.928284 71.1275 0.928284 46C0.928284 20.8725 21.3625 0.5 46.5728 0.5C71.783 0.5 92.2173 20.8725 92.2173 46Z",
    stroke: "#737791"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6125 43.0708C35.5838 41.7679 33.9667 40.4208 33.9667 38.3229C33.9667 35.9158 36.2041 34.2375 39.9479 34.2375C43.8911 34.2375 45.3531 36.1146 45.4861 38.875H50.3818C50.2267 35.0767 47.9007 31.5875 43.2708 30.4612V25.625H36.625V30.395C32.3273 31.3225 28.8715 34.105 28.8715 38.3671C28.8715 43.4683 33.1027 46.0079 39.2833 47.4875C44.8215 48.8125 45.9291 50.7558 45.9291 52.8096C45.9291 54.3333 44.8436 56.7625 39.9479 56.7625C35.3844 56.7625 33.5901 54.7308 33.3464 52.125H28.4728C28.7386 56.9612 32.3717 59.6775 36.625 60.5829V65.375H43.2708V60.6271C47.5906 59.81 51.0242 57.3146 51.0242 52.7875C51.0242 46.5158 45.6411 44.3737 40.6125 43.0708Z",
    fill: "#737791"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1262 60L62.1262 61.5L65.1262 61.5L65.1262 60L62.1262 60ZM64.6868 30.9393C64.1011 30.3536 63.1513 30.3536 62.5655 30.9393L53.0196 40.4853C52.4338 41.0711 52.4338 42.0208 53.0196 42.6066C53.6054 43.1924 54.5551 43.1924 55.1409 42.6066L63.6262 34.1213L72.1115 42.6066C72.6973 43.1924 73.647 43.1924 74.2328 42.6066C74.8186 42.0208 74.8186 41.0711 74.2328 40.4853L64.6868 30.9393ZM65.1262 60L65.1262 32L62.1262 32L62.1262 60L65.1262 60Z",
    fill: "#737791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanho);
export default __webpack_public_path__ + "static/media/ganho.d505a99d7649e842b41ad7133ac87e79.svg";
export { ForwardRef as ReactComponent };